import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

import {
  ContractLineBulkUpliftInputType,
} from '@/graphql/contracts/_generated_/contracts';
import UpdateBulkUpliftContractLinesMutation
  from '@/graphql/contracts/updateBulkUpliftContractLines.mutation.gql';

import { notificationService } from '@/services/notification/notification.client';
import { UpdateBulkUpliftContractLines, UpdateBulkUpliftContractLinesVariables } from
  '@/graphql/contracts/_generated_/updateBulkUpliftContractLines.mutation';

export interface UpliftData_Updated_Contractline {
  upliftValue: number | null;
  billingType?: string;
  newBillingPeriodValue?: string | null,
  newAnnualBillingPeriodValue?: string | null;
  contractLineID: string;
  pricePerUnit: string;
  annualBillingPeriodValue: string;
  billingPeriodValue: string;
  nextUpliftDate: Date | string;
}

export default function useUpdateBulkContractLineUplift() {
  const [_updateBulkContractLines, { loading }]
    = useMutation<UpdateBulkUpliftContractLines, UpdateBulkUpliftContractLinesVariables>(
      UpdateBulkUpliftContractLinesMutation,
      {
        client: apolloClientContracts,
        onError: (err) => notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        }),
        onCompleted: () => {
          notificationService.open({
            text: 'Uplift(s) successfully applied',
            title: 'Uplift Contract Lines',
            type: 'success'
          });
        }
      },
    );

  const updateBulkContractLines = (contractLinesToUpdate: ContractLineBulkUpliftInputType[]) => {

    return _updateBulkContractLines({
      variables: {
        contractLineUplifts: contractLinesToUpdate
      }
    }).then(result => result.data);
  };

  return {
    updateBulkContractLines,
    isLoadingUpdateContractLines: loading,
  } as const;
}
